/**
 * Phase 9 — Google Analytics 4 (gtag.js) injection.
 *
 * Consent-gated : appelé seulement si `categories.analytics === true`.
 * Idle-deferred : passe par `idleInject` côté caller.
 * `anonymize_ip: true` — Loi 25 / RGPD compliance.
 *
 * PHASE 10 : remplacer `REPLACE_AT_END_GA4_ID` par le vrai Measurement ID
 * (format G-XXXXXXXXXX) fourni par Océanne.
 */
import { idleInject } from '@/lib/perf/idle-inject';

const GA4_ID_PLACEHOLDER = 'REPLACE_AT_END_GA4_ID';
const GA4_ID: string = GA4_ID_PLACEHOLDER;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function injectGa4(measurementId: string = GA4_ID): void {
  if (typeof window === 'undefined') return;
  if (measurementId === GA4_ID_PLACEHOLDER) {
    if (import.meta.env.DEV) {
      console.warn('[ga4] skipped: placeholder not replaced (Phase 10)');
    }
    return;
  }
  if (window.gtag) return; // already injected

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer ?? [];
  function gtag(...args: unknown[]) {
    window.dataLayer!.push(args);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', measurementId, { anonymize_ip: true });
}

export function deferGa4(): void {
  idleInject(() => injectGa4());
}
